export const SMARTLEAD_ADVERTISER_COMPANY_ASSOCIATION_TYPE = {
  AGENCY_ACCOUNT: "AGENCY_ACCOUNT",
  NEW_ACCOUNT: "NEW_ACCOUNT",
  IMPORTED_ACCOUNT: "IMPORTED_ACCOUNT",
} as const;
